
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import Index from './pages/Index';
import ContactPage from './pages/ContactPage';
import NotFound from './pages/NotFound';
import Error500 from './pages/Error500';
import { Toaster } from "./components/ui/toaster";
import Privacy from './pages/Privacy';
import { lazy, Suspense, useEffect } from 'react';
import './App.css';
import Portfolio from './pages/Portfolio';
import PortfolioDetail from './pages/PortfolioDetail';
import { useAnalytics } from './hooks/useAnalytics';
import WWWRedirect from './components/WWWRedirect';

// Lazy load blog-related components
const BlogPage = lazy(() => import('./pages/BlogPage'));
const BlogPostPage = lazy(() => import('./pages/BlogPostPage'));

const ErrorFallback = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    navigate('/error-500', { replace: true });
  }, [navigate]);
  
  return null;
};

const LoadingFallback = () => (
  <div className="w-full flex justify-center items-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-navy-800"></div>
  </div>
);

const AppContent = () => {
  // Use the analytics hook to track page views
  useAnalytics();
  
  return (
    <>
      <WWWRedirect />
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/polityka-prywatnosci" element={<Privacy />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/portfolio/:slug" element={<PortfolioDetail />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/:slug" element={<BlogPostPage />} />
          <Route path="/error-500" element={<Error500 />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </>
  );
};

function App() {
  console.log('App component rendered');
  
  return (
    <Router>
      <AppContent />
      <Toaster />
    </Router>
  );
}

export default App;
